function flatten (chardata, caller='Unknown') {

    // takes chardata and flattens it
    if (caller !== "CS 05 localstorage") console.log(`flattening this [${caller}]: `, chardata )

    let flatData = { name: chardata.name }

    let sectionData = chardata.chardata.chars
    for ( var key in sectionData ) {
        flatData[key] = sectionData[key];
    }

    sectionData = chardata.chardata.stats;
    for ( key in sectionData ) {
        flatData[key] = sectionData[key];
    }

    sectionData = chardata.chardata.weapons; 
    for ( key in sectionData ) {
        flatData[key] = sectionData[key];
    }

    sectionData = chardata.chardata.armor;
    for ( key in sectionData ) {
        flatData[key] = sectionData[key];
    }

    sectionData = chardata.chardata.saves;
    for ( key in sectionData ) {
        flatData[key] = sectionData[key];
    }

    sectionData = chardata.chardata.spells;
    for ( key in sectionData ) {
        flatData[key] = sectionData[key];
    }

    sectionData = chardata.chardata.magic;
    for ( key in sectionData ) {
        flatData[key] = sectionData[key];
    }

    sectionData = chardata.chardata.items;
    for ( key in sectionData ) {;
        flatData[key] = sectionData[key];
    }

    sectionData = chardata.chardata.potions;
    for ( key in sectionData ) {;
        flatData[key] = sectionData[key];
    }

    sectionData = chardata.chardata.followers;
    for ( key in sectionData ) {
        flatData[key] = sectionData[key];
    }

    sectionData = chardata.chardata.abilities;
    for ( key in sectionData ) {;
        flatData[key] = sectionData[key];
    }

    // Add labels
    flatData.Attributes = "Attributes";
    flatData.StrTxt = "STR";
    flatData.IntTxt = "INT";
    flatData.WisTxt = "WIS";
    flatData.DexTxt = "DEX";
    flatData.ConTxt = "CON";
    flatData.ChaTxt = "CHA";
    flatData.MovTxt = "Move";
    flatData.HeiTxt = "Height";
    flatData.WeiTxt = "Weight";
    flatData.CombatHeader = "Combat";
    
    flatData.ClassTxt = "CLASS";
    flatData.LvlTxt = "LEVEL";
    flatData.XPTxt = "XP";
    flatData.NXPTxt = "NextXP";
    flatData.GoldTxt = "GOLD";
    flatData.RaceTxt = "RACE";
    flatData.AliTxt = "ALIGN";
    flatData.DeiTxt = "DEITY";
    flatData.AgeTxt = "Age";

    flatData.HPTxt = "HP";
    flatData.ToHitTxt = "ToHit";
    flatData.ACTxt = "AC";
    flatData.BaseTxt = "Base";
    flatData.RearTxt = "Rear";
    flatData.NattTxt = "#Att";

    flatData.ACbaseTxt = "base";
    flatData.ArmTxt = "Armor";
    flatData.WeaTxt = "Weapons";
    flatData.WthTxt = "to Hit";
    flatData.WdbTxt = "to Dmg";
    flatData.WdgTxt = "Damage";

    flatData.PotTxt = "Potions";
    flatData.MagTxt = "Magic Items";
    flatData.OthTxt = "Other";
    flatData.FolTxt = "Followers";
    flatData.RacTxt = "Abilities";

    flatData.SaveTxt = "Saving Throws";
    flatData.SavTxt1 = "Poison";
    flatData.SavTxt2 = 'Poly';
    flatData.SavTxt3 = 'Wand';
    flatData.SavTxt4 = 'Magic';
    flatData.SavTxt5 = 'Breath';
    flatData.SavTxt6 = 'Spc';
    flatData.SavTxt6F = "Special";

    flatData.SpellHeader = "Spells";
    flatData.Sp1Txt = "Spell 1";
    flatData.Sp2Txt = "Spell 2";
    flatData.Sp3Txt = "Spell 3";
    flatData.Sp4Txt = "Spell 4";
    flatData.Sp5Txt = "Spell 5";

    flatData.AbiTxt = "More";

    // ----- TRANSLATE DATA FOR NEW DATA SCHEMA VERSION -----
    

    if ( chardata.version ) {
        console.log(`flat.version ${Number(chardata.version) < 0.5}`, Number(chardata.version) )

        if ( Number(chardata.version) < 0.5 ) {
            
            console.log('flat updating to 0.5')

            // map chardata.chardata.spells.mySp{NN} to flatData.mySp{LXX}
            for (let i = 11; i <= 99; i++) {
                let spellKey = `mySp${i}`;
                const spellKeyChecks = `mySpk${i}`;
                if (flatData[spellKey] !== undefined ) {                
                    let level = Math.floor((i - 11) / 10) + 1; // Level is 1-5
                    let spellIndex = (i - 11) % 10 + 1; // Index is 1-10
                    const paddedSpellIndex = spellIndex.toString().padStart(2, '0');
                    flatData[`mySp${level}${paddedSpellIndex}`] = flatData[spellKey];
                    flatData[`mySpk${level}${paddedSpellIndex}`] = flatData[spellKeyChecks];
                }
                
                delete flatData[spellKey];
                delete flatData[spellKeyChecks];
            }

            // add blank    
        }
    }

    console.log('new flatdata: ', flatData )

    return flatData

}

export default flatten